import React from 'react';
import { Navigation } from '../components/Navigation';
import { Releases } from '../components/Releases';
import { Footer } from '../components/Footer';

export const ReleasesPage = () => {
  return (
    <div className="page-transition">
      <Navigation />
      <Releases />
      <Footer />
    </div>
  );
};
